import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUser, logout, setSessionExpired } from '../store/slices/authSlice';
import { useRefreshTokenMutation } from '../api/authAPI';
import Button from '../components/UI/Button';
import { CardSimple } from '../components/UI/Card';
import { useNavigate } from 'react-router-dom';

const SessionExpiredModal = () => {
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const navigate = useNavigate()

  const dispatch = useDispatch();
  const [refreshToken, { isLoading }] = useRefreshTokenMutation();

  const handleRefresh = async () => {
    try {
      const data = await refreshToken().unwrap();
      dispatch(setUser(data.user));
      setMessage("הטוקן התרענן בהצלחה")
      dispatch(setSessionExpired(false));
      switch (data.user.role) {
        case 'admin':
          navigate('/admin-dashboard')
          break
        case 'mentor':
          navigate('/mentor-dashboard')
          window.location.reload();
          break;
      }
    } catch {
      setError('שגיאה בריענון הטוקן')
      dispatch(logout());
      navigate('/login')
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
      <CardSimple className="w-full max-w-md text-center space-y-6">
        <h2 className="text-xl font-semibold text-gray-800">
          פג תוקף ההתחברות
        </h2>
        <p className="text-gray-600 text-base">
          התרעננות נדרשת כדי להמשיך. בחר פעולה:
        </p>
        <div className="flex justify-center gap-4">
          <Button
            variant="primary-dark"
            onClick={handleRefresh}
            isLoading={isLoading}
          >
            רענן
          </Button>
          <Button
            variant="danger"
            onClick={() => { dispatch(logout()); navigate('/login') }}
          >
            התנתק
          </Button>
        </div>
        {message && <p className="text-success text-center text-sm font-medium">{message}</p>}
        {error && <p className="text-danger text-center text-sm font-medium">{error}</p>}
      </CardSimple>

    </div>
  );
};

export default SessionExpiredModal;
